<template>
  <div>
    <div class="alert-large alert-large-info">
      <div class="icon-container">
        <i class="fa fa-exclamation"></i>
      </div>
      <div class="alert-content">

        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-7">
            <p class="lead m-b-none">Accept Terms and Conditions</p>
            <p class="m-b-none">Your booking is not confirmed until they are accepted and your deposit is paid.</p>

            <div class="visible-sm visible-xs m-b-sm"></div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-5 text-right">
            <a href="#" class="btn btn-info btn-block" data-toggle="modal" data-target="#modal-terms"><i class="fa fa-file-text"></i> Terms and Conditions</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>
